import StateManager from '../State/StateManager';
import TaskQueue from '../Utility/Task/TaskQueue';
import Game from '../Game';
import Scene from '../Scene/Scene';
import { IGameState } from '../State/Game/IGameState';

export interface ICoroutine {
    result?: IteratorResult<number>;
    iterator: Iterator<number>;
}

export default abstract class System {
    public store: StateManager;
    public scene: Scene;
    public taskQueue: TaskQueue<System>;
    public coroutines: ICoroutine[];

    private _active: boolean = false;

    public isActive(): boolean {
        return this._active;
    }

    constructor(state: StateManager) {
        this.store = state;
        this.taskQueue = new TaskQueue();
        this.coroutines = [];
    }

    public abstract init(): void;

    public abstract preload(): Promise<any>;

    public start(): void {
        this._active = true;
        this.onStart();
    }

    public stop(): void {
        this._active = false;
        this.onStop();
    }

    public destroy(): void {
        this.onDestroy();
        this.coroutines.forEach(routine => this.stopCoroutine(routine));
    }

    public update(): void {
        this.onUpdate();
        this.taskQueue.update();
        this.updateCoroutines();
    }

    public lateUpdate(): void {
        this.onLateUpdate();
    }

    protected abstract onStart(): void;

    protected abstract onStop(): void;

    protected abstract onDestroy(): void;

    protected abstract onUpdate(): void;

    protected abstract onLateUpdate(): void;

    private updateCoroutines() {
        const deltaTime: number = Game.ticker.getDeltaTime();
        for (let i = 0; i < this.coroutines.length; i++) {
            this.coroutines[i].result = this.coroutines[i].iterator.next(
                // @ts-ignore
                deltaTime
            );
            if (this.coroutines[i].result.done) {
                this.coroutines.splice(i--, 1);
            }
        }
    }

    public startCoroutine(iterator: Iterator<number>): ICoroutine {
        const routine: ICoroutine = {
            iterator: iterator,
            //result: iterator.next(),
        };
        this.coroutines.push(routine);

        return routine;
    }

    public stopCoroutine(routine: any) {
        const index = this.coroutines.indexOf(routine);
        if (index >= 0) this.coroutines.splice(index, 1);
    }

    public abstract handleStateChanged(state: IGameState): void;
}
